import request from '@/utils/httpRequest'

export default class ContractDeratedService {
  queryById(id) {
    return request({
      url: '/shye/contract/shyeContractDerated/queryById',
      method: 'get',
      params: { id: id }
    })
  }

  startFlow (params) {
    return request({
      url: '/shye/contract/shyeContractDerated/startFlow',
      method: 'post',
      data: params
    })
  }
}
